<template>
    <div class="sergeant-box">
        <div class="sergeant-box-bg"></div>
        <el-row class="sergeant-box-common sergeant-box-infor">
            <h3>
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
                什么是定向培养士官
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
            </h3>
            <p>
                定向培养士官是中央为加快国防和军队现代化建设需要，充分利用国民教育资源，借鉴地方高端职业技术人才培养经验，依托地方高等职业院校为部队定向培养技术复杂、培训周期较长的军地通用的专业型复合人才。
            </p>
        </el-row>
        <el-row class="sergeant-box-common sergeant-box-reason">
            <h3>
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
                为什么要填报定向培养士官
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
            </h3>
            <el-row type="flex" class="sergeant-box-reason-list">
                <el-col v-for="(item,index) in reasonList" :key="index" :span="4">
                    <img :src="item.src">
                    <h4>{{item.title}}</h4>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="sergeant-box-common sergeant-box-student">
            <h3>
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
                适合哪些考生
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
            </h3>
            <el-row>
                <img src="../../assets/images/sergeant-student-img.png" class="sergeant-box-student-img">
            </el-row>
            <el-row style="margin-bottom: 70px">
                <el-col :span="12">
                    <el-row class="sergeant-box-student-item">
                        <el-col :span="10" class="sergeant-box-student-item-title">
                            须为普通高中毕业生，适合高考成绩在三本和专科层次的考生。（男女生均有招生计划）。
                        </el-col>
                        <el-col :span="14">
                            <span class="sergeant-box-student-item-circle">1</span>
                            <span class="sergeant-box-student-item-line"></span>
                            <span class="sergeant-box-student-item-circle1"></span>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row class="sergeant-box-student-item sergeant-box-student-item-diff">
                        <el-col :span="11">
                            <span class="sergeant-box-student-item-circle1"></span>
                            <span class="sergeant-box-student-item-line"></span>
                            <span class="sergeant-box-student-item-circle">4</span>
                        </el-col>
                        <el-col :span="11" class="sergeant-box-student-item-title">
                            政治条件、身体条件符合义务兵征兵体检标准。
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 60px" class="sergeant-box-student-list">
                <el-col :span="12">
                    <el-row class="sergeant-box-student-item">
                        <el-col :span="10" class="sergeant-box-student-item-title">
                            年龄不超过20周岁，未婚。
                        </el-col>
                        <el-col :span="14">
                            <span class="sergeant-box-student-item-circle">2</span>
                            <span class="sergeant-box-student-item-line"></span>
                            <span class="sergeant-box-student-item-circle1"></span>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row class="sergeant-box-student-item sergeant-box-student-item-diff">
                        <el-col :span="11">
                            <span class="sergeant-box-student-item-circle1"></span>
                            <span class="sergeant-box-student-item-line"></span>
                            <span class="sergeant-box-student-item-circle">5</span>
                        </el-col>
                        <el-col :span="11" class="sergeant-box-student-item-title">
                            同等条件下，中共党员、军人子女、烈士子女、优秀学生干部优先录取。
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="sergeant-box-student-list1">
                <el-col :span="12">
                    <el-row class="sergeant-box-student-item">
                        <el-col :span="10" class="sergeant-box-student-item-title">
                            志愿从事国防事业，毕业后服从军队分配。
                        </el-col>
                        <el-col :span="14">
                            <span class="sergeant-box-student-item-circle">3</span>
                            <span class="sergeant-box-student-item-line"></span>
                            <span class="sergeant-box-student-item-circle1"></span>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="sergeant-box-common sergeant-box-tips">
            <h3>
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
                招生流程
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
            </h3>
            <el-row class="sergeant-box-list" type="flex">
                <el-col :span="8" v-for="(item,index) in tipsList" :key="index">
                    <img :src="item.src">
                    <h4>{{item.title}}</h4>
                    <p>{{item.desc}}</p>
                </el-col>
            </el-row>
            <el-row class="sergeant-box-common sergeant-box-nan">
                <h3>
                    <span>
                        <img src="../../assets/images/sergeant-star.png">
                    </span>
                    填报难点
                    <span>
                        <img src="../../assets/images/sergeant-star.png">
                    </span>
                </h3>
                <img src="../../assets/images/sergeant-nan-bg.png" class="sergeant-box-nan-img">
                <el-row class="sergeant-box-nan-list">
                    <el-col :span="12" class="sergeant-box-nan-item">
                        <div>看不懂定向士官招生政策</div>
                    </el-col>
                    <el-col :span="12" class="sergeant-box-nan-item sergeant-box-nan-item-diff">
                        <div>不知道可以报考哪些学校</div>
                    </el-col>
                    <el-col :span="12" class="sergeant-box-nan-item sergeant-box-nan-item-diff1">
                        <div>不知道可以填报什么专业</div>
                    </el-col>
                    <el-col :span="12" class="sergeant-box-nan-item sergeant-box-nan-item-diff sergeant-box-nan-item-diff1">
                        <div>不知道该做哪些准备</div>
                    </el-col>
                </el-row>
            </el-row>
        </el-row>
        <el-row class="sergeant-box-common sergeant-box-step">
            <h3>
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
                服务流程
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
            </h3>
            <el-row class="sergeant-box-step-list" type="flex" justify="space-between">
                <el-col :span="6">
                    <div class="sergeant-box-step-item-content">
                        <div class="sergeant-box-step-item-title">1</div>
                        <p>根据考生职业测评结果、报考意向，帮助学生确定适合报考直招士官生的学校和专业</p>
                    </div>
                    <span class="sergeant-box-step-item-line"></span>
                    <span class="sergeant-box-step-item-arrow"></span>
                </el-col>
                <el-col :span="6">
                    <div class="sergeant-box-step-item-content">
                        <div class="sergeant-box-step-item-title">2</div>
                        <p>一对一讲解服务，引导学生及家长了解定向培养士官的招生、录取特点和具体要求</p>
                    </div>
                    <span class="sergeant-box-step-item-line"></span>
                    <span class="sergeant-box-step-item-arrow"></span>
                </el-col>
                <el-col :span="6">
                    <div class="sergeant-box-step-item-content">
                        <div class="sergeant-box-step-item-title">3</div>
                        <p>根据考生具体情况制作高考志愿填报方案</p>
                    </div>
                    <span class="sergeant-box-step-item-line"></span>
                    <span class="sergeant-box-step-item-arrow"></span>
                </el-col>
                <el-col :span="6">
                    <div class="sergeant-box-step-item-content">
                        <div class="sergeant-box-step-item-title">4</div>
                        <p>指导考生进行部队或院校单位的政治考核及面试的相关培训，助力学生脱颖而出</p>
                    </div>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="sergeant-box-service sergeant-box-common sergeant-box-common1">
            <h3>
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
                服务优势
                <span>
                    <img src="../../assets/images/sergeant-star.png">
                </span>
            </h3>
            <el-row class="sergeant-box-service-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in serviceList" :key="index">
                    <img :src="item.src">
                    <h4>{{item.title}}</h4>
                    <div>{{item.desc}}</div>
                </el-col>
            </el-row>
            <el-row class="sergeant-box-infor sergeant-box-order">
                <img src="../../assets/images/channel-order.png" alt="">
                <div>
                    <span class="sergeant-box-order-title">预约专家 免费咨询</span>
                    <span class="sergeant-box-order-desc">留下联系方式，立即与专家一对一</span>
                </div>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            reasonList:[
                {src:require('../../assets/images/sergeant-reason-icon1.png'),title:'一人入伍，全家光荣'},
                {src:require('../../assets/images/sergeant-reason-icon2.png'),title:'三年学费全免'},
                {src:require('../../assets/images/sergeant-reason-icon3.png'),title:'国家重点培养'},
                {src:require('../../assets/images/sergeant-reason-icon4.png'),title:'入学即享兵龄'},
                {src:require('../../assets/images/sergeant-reason-icon5.png'),title:'入伍即转士官'},
                {src:require('../../assets/images/sergeant-reason-icon6.png'),title:'专业技能性强'},
                {src:require('../../assets/images/sergeant-reason-icon7.png'),title:'福利待遇优越'},
                {src:require('../../assets/images/sergeant-reason-icon8.png'),title:'有机会考军校，成为 职业军人'},
                {src:require('../../assets/images/sergeant-reason-icon9.png'),title:'退伍安置就业'},
                {src:require('../../assets/images/sergeant-reason-icon10.png'),title:'退伍国家补贴高'},
                {src:require('../../assets/images/sergeant-reason-icon11.png'),title:'学历从军两不误'},
            ],
            tipsList:[
                {src:require('../../assets/images/sergeant-tips-icon1.png'),title:'填报志愿',desc:'在提前批次填报志愿，考生须参加高考考试，填写相应高校“直招士官生”专业。'},
                {src:require('../../assets/images/sergeant-tips-icon2.png'),title:'体格检查',desc:'接到体检通知后，务必在规定的时间内，携带高考《准考证》及3张红底一寸正面免冠照片，到指定地点参加体检。'},
                {src:require('../../assets/images/sergeant-tips-icon3.png'),title:'政治考核和面试',desc:'接到面试与政治考核通知后，到指定地点参加由招收部队、招收院校与兵役机关组织的面试与政治考核。'},
                {src:require('../../assets/images/sergeant-tips-icon4.png'),title:'录取',desc:'收到录取通知书后，按照规定前往院校（中共党员、优秀学生干部、军人子女、烈士子女优先录取）。'},
                {src:require('../../assets/images/sergeant-tips-icon5.png'),title:'学历',desc:'全日制统招大专学历，学制3年。'},
            ],
            serviceList: [
                {src:require('../../assets/images/sergeant-service-icon1.png'),title:'团队优势',desc:'荔枝新高考顶级专家团队全程跟踪,一对一线上线下规划指导'},
                {src:require('../../assets/images/sergeant-service-icon2.png'),title:'流程优势',desc:'一站式服务、自我评估、目标定位、院校选择多重指导等'},
                {src:require('../../assets/images/sergeant-service-icon3.png'),title:'品牌保障',desc:'可靠的品牌支撑，实力、可信、靠谱'},
            ],
            formInline: {
                username: '',
                phone: '',
                type: '4'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            }
        };
    },

    mounted() {
        
    },

    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$font-family: 'MicrosoftYaHei';
$margin: 0 auto;
$width: 1200px;
@font-face {
    font-family: 'Impact';
    src: url('../../assets/fonts/Impact.ttf');
}
@font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
.sergeant-box-bg {
    background: url('../../assets/images/sergeant-bg.png') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 602px;
}
.sergeant-box-common {
    h3 {
        margin: 0;
        padding: 0;
        font-size: 40px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 52px;
        letter-spacing: 4px;
        span {
            position: relative;
            top: 2px;
        } 
        span:last-child {
            left: -4px;
        }
    }
}
.sergeant-box-infor {
    height: 327px;
    background: #fff6e8;
    h3 {
        margin-top: 55px;
        margin-bottom: 40px;
    }
    p {
        width: $width;
        font-family: $font-family;
        font-size: 22px;
        font-weight: 400;
        color: #2c3331;
        line-height: 44px;
        margin: $margin;
    }
}
.sergeant-box-reason {
    border-top: 14px solid #ffbc99;
    border-bottom: 14px solid #ffbc99;
    background: url('../../assets/images/sergeant-reason.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 628px;
    h3 {
        margin: 64px 0 68px 0;
        color: #fff;
    }
    .sergeant-box-reason-list {
        width: 1180px;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            text-align: center;
            margin-bottom: 63px;
            h4 {
                font-size: 20px;
                font-family:$font-family;
                font-weight: 400;
                color: #ffffff;
                line-height: 32px;
                margin: 0;
                margin-top: 18px;
            }
        }
    }
}
.sergeant-box-student {
    width: $width;
    margin: $margin;
    height: 788px;
    h3 {
        margin-top: 63px;
        margin-bottom: 82px;
    }
    span {
        display: inline-block;
    }
    .sergeant-box-student-img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -46px;
    }
    .sergeant-box-student-item {
        // position: relative;
        height: 140px;
        display: flex;
        align-items: center;
        margin-left: 5px;
        .el-col-11 {
           text-align: right;
           padding-right: 35px;
        }
    }
    .sergeant-box-student-item-title {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 36px;
    }
    .sergeant-box-student-item-circle {
        width: 86px;
        height: 86px;
        background: linear-gradient(180deg,#ffa957, #ff8b58);
        border: 1px solid #ea7a00;
        border-radius: 44px;
        font-family: 'Impact';
        font-weight: 400;
        text-align: center;
        color: #fff6e8;
        line-height: 86px;
        font-size: 40px;
        margin-left: 10px;
    }
    .sergeant-box-student-item-line {
        width: 119px;
        height: 2px;
        border-top: 1px dashed #d7d7d7;
        position: relative;
        top: -4px;
    }
    .sergeant-box-student-item-circle1 {
        width: 12px;
        height: 12px;
        background: rgba(255,255,255,0.60);
        border: 1px solid #d7d7d7;
        border-radius: 50%;
    }
    .sergeant-box-student-item-diff {
        margin-left: 0;
        .sergeant-box-student-item-circle {
            margin-left: 0;
        }
        .sergeant-box-student-item-title {
            margin-left: -16px;
            text-align: left;
        }
    }
    .sergeant-box-student-list {
        .sergeant-box-student-item-line {
            width: 78px;
        }
    }
    .sergeant-box-student-list1 {
        .sergeant-box-student-item-line {
            width: 140px;
        }
    }
}
.sergeant-box-tips {
    background: url('../../assets/images/sergeant-tips-bg.jpg') no-repeat center;
    background-size: cover;
    height: 1334px;
    width: 100%;
    h3 {
        margin: 64px 0;
    }
    .sergeant-box-list {
        width: $width;
        margin: $margin;
        text-align: center;
        flex-wrap: wrap;
        .el-col {
            padding: 0 35px;
            margin-bottom: 46px;
        }
        h4 {
            font-size: 28px;
            font-family: $font-family;
            font-weight: 700;
            color: #332e2c;
            line-height: 37px;
            letter-spacing: 2.8px;
            margin: 22px 0 20px 0;
        }
        p {
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            color: #66605e;
            line-height: 36px;
            text-align: left;
            margin: 0;
        }
    }
}
.sergeant-box-nan {
    width: $width;
    margin: $margin;
    height: 662px;
    background: rgba(255,255,255,0.92);
    border-radius: 20px;
    box-shadow: 0px 8px 20px 0px rgba(133,0,0,0.17), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(6px);
    margin-top: 20px;
    position: relative;
    z-index: 99;
    text-align: center;
    padding: 0 150px;
    h3 {
        margin: 66px 0;
    }
    .sergeant-box-nan-img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .sergeant-box-nan-item {
        margin-bottom: 164px;
        div {
            width: 296px;
            height: 114px;
            background: #fff4f1;
            border: 2px solid #c70008;
            border-radius: 20px;
            box-shadow: 0px 0px 20px 0px rgba(97,0,4,0.13);
            font-size: 24px;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 36px; 
            padding: 21px 32px;
            box-sizing: border-box;
        }
    }
    .sergeant-box-nan-item-diff {
        div {
            float: right;
        }
    }
    .sergeant-box-nan-item-diff1 {
        margin-bottom: 0;
    }
}
.sergeant-box-step {
    height: 869px;
    background: #c70008;
    border-top: 14px solid #ffbc99;
    h3 {
        margin-top: 400px;
        color: #fff;
    }
    .sergeant-box-step-list {
        margin: $margin;
        width: $width;
        margin-top: 90px;
        .el-col-6 {
            position: relative;
            width: 258px;
        }
        .sergeant-box-step-item-line {
            display: inline-block;
            width: 45px;
            border-top: 2px dashed #ffa557;
            position: absolute;
            left: 258px;
            top: 50%;
            transform: translateY(-50%);
        }
        .sergeant-box-step-item-arrow {
            display: inline-block;
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-left: 16px solid #ffa557;
            border-bottom: 8px solid transparent;
            position: absolute;
            left: 300px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    .sergeant-box-step-item-content {
        width: 258px;
        height: 229px;
        background: #fff2de;
        border: 2px solid #ffc99a;
        border-radius: 20px;
        padding: 0 24px 0 30px;
        box-sizing: border-box;
        p {
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            color: #66605e;
            line-height: 36px;
            margin: 0;
            margin-top: 24px;
        }
    }
    .sergeant-box-step-item-title {
        width: 74px;
        height: 74px;
        background: linear-gradient(180deg,#ffa957, #ff8b58);
        border: 1px solid #ea7a00;
        border-radius: 43px;
        font-size: 40px;
        font-family: 'Impact';
        font-weight: 400;
        text-align: center;
        color: #fff6e8;
        line-height: 74px;
        margin: $margin;
        margin-top: -40px;
    }
}
.sergeant-box-service {
    height: 1011px;
    background: url('../../assets/images/sergeant-service-bg.jpg') no-repeat;
    background-size: cover;
    width: 100%;
    background-position: center;
    margin-bottom: -56px;
    h3 {
        margin-top: 64px;
    }
    .sergeant-box-service-list {
        width: $width;
        margin: $margin;
        margin-top: 110px;
        .el-col {
            width: 351px;
            height: 326px;
            background: #fff2de;
            border: 1px solid #ffc99a;
            border-radius: 20px;
            box-shadow: 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
            backdrop-filter: blur(6px);
            padding: 32px 40px 32px 43px;
            box-sizing: border-box;
            text-align: center;
            img {
                margin-top: -100px;
            }
            h4 {
                font-size: 30px;
                font-family: $font-family;
                font-weight: 700;
                text-align: center;
                color: #2c3331;
                line-height: 36px;
                margin: 30px 0 24px 0;
            }
            div {
                font-size: 22px;
                font-family: $font-family;
                font-weight: 400;
                color: #5e6663;
                line-height: 40px;
                text-align: left;
            }
        }
    }

}
.sergeant-box-order {
    @include gwidth;
    width: 1200px;
    height: 255px;
    background: linear-gradient(180deg,#ff9e4a, $common-color);
    border-radius: 20px;
    box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
    padding: 48px;
    margin-top: 114px;
    position: relative;
    margin-bottom: 28px;
    span {
        display: inline-block;
    }
    img {
        position: absolute;
        top:0;
        left: 0;
    }
    .sergeant-box-order-title {
        font-size: 36px;
        font-family: 'zihun443hao';
        color: #ffffff;
    }
    .sergeant-box-order-desc {
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
    }
}
</style>